import script from "./bridge.vue?vue&type=script&lang=jsx"
export * from "./bridge.vue?vue&type=script&lang=jsx"

const __exports__ = script;

export default __exports__